import React from "react";
import { useTranslation } from "react-i18next";

const Tutorial5 = () => {
  const { t } = useTranslation();
  const tutorial5 = "/images/mo/pngjpg/tutorial5.png";
  return (
    <div>
      <div className="pt-[25.5px] flex justify-center ">
        <div className="w-[375px] h-[329px] flex items-center justify-center relative">
          <img src={tutorial5} alt="tutorial4" />
        </div>
      </div>
      <div className="flex items-center flex-col pt-[50px]">
        <span className="block text-[#1B5EDC] h2_800">{t('Tutorial5_viewRecord', '기록 보기')}</span>
        <div className="text-[#343B48] text-center body_1_400 pt-[8px]">
          <div>{t('Tutorial5_stomaRecordAndFeedback', '장루상태 기록과 간호사의 피드백,')}</div>
          <div>{t('Tutorial5_viewAtGlance', '건강일까지 한 눈에 볼 수 있어요.')}</div>
        </div>
      </div>
    </div>
  );
};

export default Tutorial5;
